import React, { useState, useEffect, useCallback } from "react";
import './../../App.css';
import './../Maintenance/Maintenance.css';
import {CreateSearchBarWithPlaceHolder} from '../CommonObjects';
import {SetAuditTrailBulk} from './../Reports/AuditTrailReportEmployeeSetup';
import axios from 'axios';
import {CreateTable} from '../ManageTable';
import {token, domain} from '../Security';
import loadingSpinner from './../../assets/loading.gif';
// icon
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function Pagibig({user, isHideSideMenu}) {
    var header = [
        "ID",
        "Pagibig Employee Share",
        "Pagibig Employer Share",
        "",
    ]
    var accessor = [
        "id",
        "employee",
        "employer",
        "manage"
    ]

    const [currentPage, setCurrentPage] = useState(1);

    const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [pagibig, setPagibig] = useState([]);
    const [selectedData, setSelectedData] = useState(null);
    // Retrieve
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("----Select filter----");
    // Update
    const [showEditForm, setShowEditForm] = useState(false);
    const [employee, setEmployee] = useState("");
    const [employer, setEmployer] = useState("");
    //old
    const [oldEmployee, setOldEmployee] = useState("");
    const [oldEmployer, setOldEmployer] = useState("");
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const apiUrl =  domain + "/api/Pagibig";

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const response = await axios.get(apiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            setPagibig(response.data); // Set the response data to the state
            setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [apiUrl]);

    useEffect(() => {
        fetchData();
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("----Select filter----")
                break;
            case 1:
                setSearchPlaceholder("Search by pagibig id")
                break;
            default:
                setSearchPlaceholder("----Select filter----")
                break;
        }
    }, [fetchData, filterDataIndex]);

    const handleFilter = (value) => {
        setCurrentPage(1);
        
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                return;
            case 1:
                res = filterData.filter((f) =>
                f.id.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                break;
        }

        setPagibig(res);
    };
    const handleSubmit = async (event) => {
        event.preventDefault();

        const data = {
            employee: employee,
            employer: employer
        };

        try {
            setLoadingRequest(true);
            await axios.put(`${apiUrl}/${selectedData.id}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            let auditInfo = [];

            if(data.employee !== oldEmployee){
                auditInfo.push({
                    setupArea: "Pagibig",
                    actionTaken: "update",
                    field: "Employee",
                    newValue: `${data.employee}`,
                    oldValue: `${oldEmployee}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            if(data.employer !== oldEmployer){
                auditInfo.push({
                    setupArea: "Pagibig",
                    actionTaken: "update",
                    field: "Employer",
                    newValue: `${data.employer}`,
                    oldValue: `${oldEmployer}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            setShowEditForm(false); // Hide the add form
            await SetAuditTrailBulk({data: auditInfo});
            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setEmployee("");
            setEmployer("");
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowEditForm(false);
    };

    const editHandleClick = (data) => {
        setSelectedData(data)
        setShowEditForm(true);
        setEmployee(data.employee);
        setEmployer(data.employer);
        setOldEmployee(data.employee);
        setOldEmployer(data.employer);
    };
    const closeEditHandleClick = () => {
        setShowEditForm(false);
    };

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="MainteInfo">
                        <div className="mainteHeader">
                            <div className='sub-title row'>
                                < span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Government Premiums >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Pagibig"}</span>
                            </div>
                            <h3>Pagibig</h3>
                        </div>
                        <div className="mainte-body">
                            <div style={{display: "none"}}>
                                {Filter(setFilterDataIndex)}
                                <div className="mainte-body-top row">
                                    {CreateSearchBarWithPlaceHolder("", "mainte-search row", "mainte-search-icon", "mainte-search-input", (e)=>handleFilter(e.target.value), searchPlaceholder, SearchIcon)}
                                </div>
                            </div>
                            <div className="maintenance-table container">
                                <CreateTable
                                    dataList={pagibig}
                                    dataHeader={header}
                                    dataAccessor={accessor}
                                    editHandleClick={editHandleClick}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                />
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            {EditForm(showEditForm, 
                    setShowEditForm,
                    employee,
                    employer,
                    setEmployee,
                    setEmployer, 
                    handleSubmit)}
            <EditForm  isOpen={showEditForm} 
                    onClose={closeEditHandleClick}
                    employee={employee}
                    employer={employer}
                    setEmployee={setEmployee}
                    setEmployer={setEmployer}
                    handleSubmit={handleSubmit}
            >
            </EditForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest || loading ? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}
function EditForm({isOpen, 
    onClose,  
    employee,
    employer,
    setEmployee,
    setEmployer,
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(employee === ""
            || employer === ""
        ){
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setEmployee("");
        setEmployer("");
        setErrorState(false);
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Update Pagibig</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <input
                                type="number"
                                id="employee"
                                placeholder="Employee Contribution"
                                value={employee}
                                onChange={(e) => setEmployee(e.target.value)}
                                />
                            </div>
                            <span style={{
                                    visibility: employee === "" && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employer</div>
                            <div className="info-item-input">
                                <input
                                type="number"
                                id="employer"
                                placeholder="Employer Contribution"
                                value={employer}
                                onChange={(e) => setEmployer(e.target.value)}
                                />
                            </div>
                            <span style={{
                                    visibility: employer === "" && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function Filter(setFilterDataIndex){
    const [selectedOption, setSelectedOption] = useState('');

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "PagibigId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="PagibigId">Pagibig Id</option>
            </select>
        </div>
    );
};
export default Pagibig
